import { Box, Container, Typography, Button } from "@mui/material";
import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import { trackScreenView, fireGAEvent } from '../lib/gtag.js';

export default function BBFTheReckoningAnimated() {
  const hasTrackedRef = useRef(false);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  useEffect(() => {
    const detectPlatform = () => {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(ua)) return 'android';
      if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
      return 'desktop';
    };

    if (inView && !hasTrackedRef.current) {
      const platform = detectPlatform();
      trackScreenView(`BBFTheReckoningAnimated::${platform}`);
      hasTrackedRef.current = true;
    }
  }, [inView]);

  const handleCTA = () => {
    fireGAEvent("cta_click", {
      event_category: "Button Click",
      event_label: "The Truth Is in the Wreckage",
      screen_name: "BBFTheReckoningAnimated",
      value: 1,
      version: "1.0.0",
    });

    const target = document.getElementById("BBFTheReckoning");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      id="BBFTheReckoningAnimated"
      sx={{
        minHeight: "85vh",
        backgroundColor: "#000",
        color: "#fff",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
        pt: { xs: 6, md: 10 },
      }}
    >
      <Container maxWidth="md" ref={ref}>
        <Typography
          variant="h2"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2.25rem", md: "3.25rem" },
            lineHeight: 1.3,
          }}
        >
          With Biden, The World Went
          <br />
          Off the Rails
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontSize: { xs: "1rem", md: "1.25rem" },
            lineHeight: 1.6,
            color: "#ccc",
          }}
        >
          And the reckoning has now begun.
        </Typography>

        <Button
          variant="contained"
          size="large"
          sx={{
            mt: 5,
            backgroundColor: "#f44336",
            color: "#fff",
            ":hover": {
              backgroundColor: "#d32f2f",
            },
          }}
          onClick={handleCTA}
        >
          The Truth Is in the Wreckage
        </Button>
      </Container>
    </Box>
  );
}